module.exports = __webpack_public_path__ + "img/ic-processing.1a2a7b03.gif";